import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <span class="created-by">Created with ♥ by <b>Gavesha Labs</b> © {{year}}</span>
  <small style="color: white;">[ {{version}} ]</small>
  `,
})
export class FooterComponent {

  get year() {
    return new Date().getFullYear();
  }

  get version() {
    return environment.version;
  }
}
